import React, { useState } from 'react'
import { Container, Typography, Stack, Paper, useTheme, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Navbar } from '../features/navigation/components/Navbar'
import { Footer } from '../features/footer/Footer'

export const FAQPage = () => {
  const theme = useTheme()
  const [expanded, setExpanded] = useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const faqs = [
    {
      id: 'panel1',
      question: 'What is NEXO Shop?',
      answer: 'NEXO Shop is an e-commerce platform specializing in premium perfumes. We offer a wide selection of authentic fragrances with doorstep delivery across Pakistan.'
    },
    {
      id: 'panel2',
      question: 'How do I place an order?',
      answer: 'Simply browse our perfume collection, add items to your cart, proceed to checkout, select your payment method, and upload your payment proof. Your order will be confirmed within 24 hours.'
    },
    {
      id: 'panel3',
      question: 'What are the payment methods?',
      answer: 'We accept multiple payment methods: Bank Transfer (HBL Account: 04897903603003), Easy Paisa (+923448252109), and WhatsApp Transfers (+923448252109).'
    },
    {
      id: 'panel4',
      question: 'How long does delivery take?',
      answer: 'Orders typically take 7-9 business days for delivery across Pakistan, depending on your location and order volume.'
    },
    {
      id: 'panel5',
      question: 'Can I return products?',
      answer: 'Yes, we accept returns within 7 days of delivery for unopened, original products. Contact our support for return instructions.'
    },
    {
      id: 'panel6',
      question: 'Are all products authentic?',
      answer: 'Absolutely! We source all our perfumes from verified suppliers. Each product is authentic and comes with proper packaging.'
    },
    {
      id: 'panel7',
      question: 'How do I track my order?',
      answer: 'You can track your order status in your profile under "My Orders" section after placing an order.'
    },
    {
      id: 'panel8',
      question: 'What if I have product issues?',
      answer: 'Contact our support team via WhatsApp (+923448252109) or email (sardarlaeiq786@gmail.com). We\'ll resolve any issues promptly.'
    },
    {
      id: 'panel9',
      question: 'Do you offer sample products?',
      answer: 'Yes! Visit our "Testers" section to explore sample sizes of our popular fragrances at discounted prices.'
    },
    {
      id: 'panel10',
      question: 'How can I become a tester?',
      answer: 'Check out our "Testers" page to see current opportunities and submit an application. Testers receive exclusive benefits and early access to new products.'
    },
    {
      id: 'panel11',
      question: 'Is there a referral program?',
      answer: 'Yes! Refer friends to NEXO Shop and earn discounts on your next purchase. Check your account for referral details.'
    },
    {
      id: 'panel12',
      question: 'How do I submit a product review?',
      answer: 'After receiving your order, visit the product page and click "Add Review" to share your experience, rating, and photos.'
    }
  ]

  return (
    <Stack minHeight="100vh" sx={{ display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Container maxWidth="md" sx={{ flex: 1, py: 4 }}>
        <Paper elevation={3} sx={{ p: 4, backgroundColor: theme.palette.background.paper }}>
          <Typography variant="h3" sx={{ mb: 1, fontWeight: 'bold', color: theme.palette.primary.main }}>
            Frequently Asked Questions
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
            Find answers to common questions about NEXO Shop
          </Typography>

          <Stack spacing={1}>
            {faqs.map((faq) => (
              <Accordion 
                key={faq.id} 
                expanded={expanded === faq.id} 
                onChange={handleChange(faq.id)}
                sx={{
                  border: `1px solid ${theme.palette.divider}`,
                  '&:before': {
                    display: 'none'
                  }
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ backgroundColor: theme.palette.grey[50] }}>
                  <Typography variant="body2">
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>

          <Paper elevation={0} sx={{ p: 3, mt: 4, backgroundColor: theme.palette.primary.lighter || '#f5f5f5' }}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
              Still have questions?
            </Typography>
            <Typography variant="body2">
              Contact our support team at sardarlaeiq786@gmail.com or WhatsApp: +923448252109
            </Typography>
          </Paper>
        </Paper>
      </Container>
      <Footer />
    </Stack>
  )
}
